import dayjs from "dayjs";
import * as yup from "yup";
import i18n from "shared/i18n";
import { yupResolver } from "@hookform/resolvers/yup";

// TODO better way of formatting dates

const parseDateString = (value) => {
  const formatted = dayjs(value);
  return formatted.isValid() ? formatted.format("YYYY-MM-DD HH:mm:ss") : null;
};

export const getTravelLineResolvers = () => {
  const privateTimeOnSaveResolver = yupResolver(
    yup.object().shape({
      interval_type_id: yup.mixed().nullable(),
      start_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .nullable(),
      end_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .nullable(),
      start_time: yup.string().transform(parseDateString).nullable(),
      end_time: yup.string().transform(parseDateString).nullable(),
    })
  );
  const privateTimeOnSubmitResolver = yupResolver(
    yup.object().shape({
      interval_type_id: yup.mixed().nullable(),
      start_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .nullable(),
      end_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .nullable(),
      start_time: yup
        .string()
        .transform(parseDateString)
        .typeError(
          i18n.t("validations.start_time.is_required", { ns: "TravelLine" })
        ),
      end_time: yup
        .string()
        .transform(parseDateString)
        .typeError(
          i18n.t("validations.end_time.is_required", { ns: "TravelLine" })
        ),
    })
  );
  const onSaveResolver = yupResolver(
    yup.object().shape({
      interval_type_id: yup.mixed().nullable(),
      start_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .nullable(),
      end_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .nullable(),
      vehicle_info: yup.mixed().nullable(),
      start_time: yup.string().transform(parseDateString).nullable(),
      end_time: yup.string().transform(parseDateString).nullable(),
      border_crossing_time: yup.string().transform(parseDateString).nullable(),
      attachments: yup.array().of(yup.number()),
      distance: yup.number().nullable(),
    })
  );
  const onSubmitResolver = yupResolver(
    yup.object().shape({
      interval_type_id: yup.mixed().test(
        "is-object",
        i18n.t("validations.interval_type_id.is_required", {
          ns: "TravelLine",
        }),
        (value) => !(value === undefined || value === null)
      ),
      start_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .typeError(
          i18n.t("validations.start_place_id.is_required", { ns: "TravelLine" })
        ),
      end_place_id: yup
        .number()
        .transform((_, originalValue) => originalValue?.value ?? null)
        .typeError(
          i18n.t("validations.end_place_id.is_required", { ns: "TravelLine" })
        ),
      vehicle_info: yup.mixed().when("interval_type_id", {
        is: (value) => value?.label === "Car",
        then: (schema) =>
          schema.required(
            i18n.t("validations.vehicle_info.is_required", { ns: "TravelLine" })
          ),
        otherwise: (schema) => schema.nullable(true),
      }),
      start_time: yup
        .string()
        .transform(parseDateString)
        .typeError(
          i18n.t("validations.start_time.is_required", { ns: "TravelLine" })
        ),
      end_time: yup
        .string()
        .transform(parseDateString)
        .typeError(
          i18n.t("validations.end_time.is_required", { ns: "TravelLine" })
        ),
      border_crossing_time: yup.string().transform(parseDateString).nullable(),
      attachments: yup.array().of(yup.number()),
      distance: yup
        .number()
        .when(["interval_type_id", "vehicle_info"], {
          is: (intervalType, vehicleInfo) =>
            intervalType?.label === "Car" &&
            // ! Values of private car starts with "1_"
            vehicleInfo?.value?.toString()?.startsWith("1_"),
          then: (schema) => schema.nullable(false),
          otherwise: (schema) => schema.nullable(true),
        })
        .typeError(
          i18n.t("validations.distance.is_required", { ns: "TravelLine" })
        ),
    })
  );

  return {
    onSaveResolver,
    onSubmitResolver,
    privateTimeOnSaveResolver,
    privateTimeOnSubmitResolver,
  };
};
